const e = "Experienced";
const i = "Intermediate";

const myExperience = {
  frontEndskills: [
    {
      name: "HTML",
      level: e,
    },
    {
      name: "CSS",
      level: e,
    },
    {
      name: "JavaScript",
      level: e,
    },
    {
      name: "TypeScript",
      level: i,
    },
    {
      name: "ReactJs",
      level: e,
    },
    {
      name: "NextJs",
      level: e,
    },
    {
      name: "Redux",
      level: e,
    },
    {
      name: "Jest",
      level: i,
    },
    {
      name: "TailwindCss",
      level: e,
    },
    {
      name: "BootStrap",
      level: e,
    },
    {
      name: "Material UI",
      level: i,
    },
    {
      name: "React Suite",
      level: e,
    },
  ],
  backEndSkills: [
    {
      name: "NodeJs",
      level: e,
    },
    {
      name: "ExpressJs",
      level: e,
    },
    {
      name: "Rest APIs",
      level: e,
    },
    {
      name: "MongoDb",
      level: i,
    },
    {
      name: "Swagger",
      level: e,
    },
    {
      name: "Postman",
      level: e,
    },
    {
      name: "Firebase",
      level: e,
    },
    {
        name: "AWS",
        level: i,
      },
    {
      name: "GitHub",
      level: e,
    },
    {
      name: "BitBucket",
      level: e,
    },
  ],
};

export default myExperience;
